import { useEffect } from "react";

import { CATEGORY_META } from "../lib/icons";

import type { Counts } from "./Chips";

interface Props {
  open: boolean;
  active: string | null;
  counts: Counts;
  onSelect: (category: string | null) => void;
  onClose: () => void;
}

const ORDER = ["reminder", "event", "task", "note", "link", "shopping"];

export function FilterSheet({ open, active, counts, onSelect, onClose }: Props) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  const pick = (c: string | null) => {
    onSelect(c);
    onClose();
  };
  const total = Object.values(counts).reduce((a, b) => a + b, 0);

  return (
    <>
      <div className="sheet-backdrop" data-open={open} onClick={onClose} />
      <div className="sheet" data-open={open} role="dialog" aria-label="Filter">
        <div className="sheet-handle" />
        <p className="sheet-title">Filter</p>
        <div className="sheet-list">
          <button
            className="sheet-item"
            aria-pressed={active === null}
            onClick={() => pick(null)}
          >
            <span style={{ width: 10 }} />
            <span>All captures</span>
            <span className="count">{total}</span>
          </button>
          {ORDER.map((c) => {
            const meta = CATEGORY_META[c];
            if (!meta) return null;
            return (
              <button
                key={c}
                className="sheet-item"
                aria-pressed={active === c}
                style={{ ["--chip-color" as string]: meta.color }}
                onClick={() => pick(active === c ? null : c)}
              >
                <span className="dot" />
                <span>{meta.plural}</span>
                <span className="count">{counts[c] ?? 0}</span>
              </button>
            );
          })}
        </div>
      </div>
    </>
  );
}
